import { type api, isDefined } from 'common';

import { EMPTY_CONTENT } from '../../utils/constants';

export type User = api.User.User;
export type UserBasic = api.User.UserBasic;

export function formatUserName(user: Pick<User, 'firstName' | 'lastName'>): string {
  const { firstName, lastName } = user;

  if (!isDefined(firstName) && !isDefined(lastName)) {
    return EMPTY_CONTENT;
  }

  return `${isDefined(firstName) ? firstName : ''} ${isDefined(lastName) ? lastName : ''}`;
}

export function getUserInitials(user?: Pick<User, 'firstName' | 'lastName'>): string {
  if (!user) {
    return '?';
  }
  const first = (user.firstName || '').trim();
  const last = (user.lastName || '').trim();
  const f = first ? first[0] : '';
  const l = last ? last[0] : '';
  const initials = `${f}${l}`;
  return initials.toUpperCase();
}
